import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';

type SelectedPunches = Immutable.Set<string>;

export interface PunchListActions {
  setSelectedPunches: (
    actionParams: AppStateActionParams,
    selectedPunches: Immutable.Set<string>
  ) => AppState;

  addSelectedPunch: (
    actionParams: AppStateActionParams,
    PunchId: string
  ) => AppState;

  deleteSelectedPunch: (
    actionParams: AppStateActionParams,
    PunchId: string
  ) => AppState;
}

const punchListActions: PunchListActions = {
  setSelectedPunches: (
    { state }: AppStateActionParams,
    selectedPunches: Immutable.Set<string>
  ): AppState => {
    return state().set('selectedPunches', selectedPunches);
  },

  addSelectedPunch: (
    { state }: AppStateActionParams,
    PunchId: string
  ): AppState => {
    return state().update(
      'selectedPunches',
      (selectedPunches: SelectedPunches): SelectedPunches =>
        selectedPunches.add(PunchId)
    );
  },

  deleteSelectedPunch: (
    { state }: AppStateActionParams,
    PunchId: string
  ): AppState => {
    return state().update(
      'selectedPunches',
      (selectedPunches: SelectedPunches): SelectedPunches =>
        selectedPunches.delete(PunchId)
    );
  },
};

export default punchListActions;
